const BelieveSection = ({ attributes }) => {
  return (
    <div className="mt-32 mb-48 flex flex-col items-start rounded-md bg-pink-3 p-10 lg:flex-col">
      <h2 className="mb-8 font-satoshi-bold text-[36px]">What we believe in</h2>
      <div className="flex w-full flex-col items-center justify-center text-left lg:flex-row">
        <div className="mr-6 grid w-full grid-flow-col grid-rows-2 gap-6 md:w-auto">
          {attributes.features.map((item) => (
            <div className="font-black" key={item.id}>
              <h6 className="mb-2 font-satoshi-bold text-[18px] lg:text-[20px]">{item.heading}</h6>
              <div className="text-body font-satoshi-medium">{item.description}</div>
            </div>
          ))}
        </div>

        <img
          src={attributes.image.data.attributes.url}
          alt=""
          className="rounded-md md:mr-4 md:-mt-4 lg:h-[25rem] lg:w-[50%]"
        />
      </div>
    </div>
  );
};

export default BelieveSection;
